<div class="filter-popover-inner" (click)="$event.stopPropagation()">
        <div class="filter-list">
            <ng-container *ngIf="options && options.length > 0; else emptyOptions">
                <div *ngFor="let opt of options" class="filter-item">
                    <label>
                        <input type="checkbox" [checked]="localSelection.has(opt)" (change)="toggle(opt)"> {{opt}}
                    </label>
                </div>
            </ng-container>
            <ng-template #emptyOptions>
                <div class="filter-item empty">
                    <label>
                    
                        <span class="empty-text">No filter options available</span>
                    </label>
                </div>
            </ng-template>
        </div>
    <div class="filter-actions">
        <ng-container *ngIf="options && options.length > 0; else onlyCancel">
            <button class="reset-btn" (click)="onReset()" [disabled]="!actionsEnabled">Reset</button>
            <button class="cancel-btn" (click)="onCancel()">Cancel</button>
            <button class="apply-btn" (click)="onApply()" [disabled]="!actionsEnabled">Apply</button>
        </ng-container>
        <ng-template #onlyCancel>
            <button class="cancel-btn" (click)="onCancel()">Cancel</button>
        </ng-template>
    </div>
</div>